<template>
    <div class="row no-gutters flex-fill viewer-panel">
        <div class="col-12">
            <template v-if="loading">
                <div class="loading">
                    <div class="">
                        <div class="full-size-loader"></div>
                    </div>
                </div>
            </template>
            <template v-else>
                <template v-if="loadingError" >
                    <div class="alert alert-danger" role="alert">
                        {{ errorMsg }}
                    </div>
                </template>
                <template v-else-if="result">
                    <div class="viewer-results">
                        <component
                            :is="viewer"
                            :data="viewerData"
                        />
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>

import FeatureViewerMixin from '../FeatureViewerMixin';
import { toCamelCase } from '@config/utils';

export default
{
    name: 'DefaultInfoViewer',
    mixins: [
        FeatureViewerMixin
    ],
    components: {
        AccordionViewer: () => import(/* webpackChunkName: "viewer-accordion" */ './../viewers/AccordionViewer'),
        TabViewer: () => import(/* webpackChunkName: "viewer-tab" */ './../viewers/TabViewer'),
    },
    props: {
        componentId: {
            type: String,
            require: true,
        },
        url: {
            type: String,
            default: null,
        },
        data: {
            type: Object,
            default: null,
        },
        appresentation: {
            type: String,
            default: 'accordion',
            validator: function (prop) {
                let valid = [
                    'accordion',
                    'tab',
                ];
                return valid.includes(prop);
            }
        },
    },
    data() {
        return {
            idPanel: null,
        }
    },
    beforeMount () {
        this.idPanel = this.componentId;
    },
    mounted () {
        this.prepareItemData();
    },
    computed: {
        viewer() {
            return `${toCamelCase(this.appresentation, true)}Viewer`;
        },
    },
    methods: {
        prepareItemData: function() {
            if(this.data) {
                this.result = this.data;
            } else if(this.url) {
                this.recordSearch({url: this.url, options: {}});
            }
        },
    },
    watch: {
        // showModal: {
        //     immediate: false,
        //     handler(value, oldVal) {
        //         if(value){
        //             this.initialize();
        //         }
        //     },
        // },
    },

}

</script>
